import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'toggle-switch',
    templateUrl: './toggle-switch.html',
})

export class ToggleSwitchComponent implements OnInit {
    // output
    @Output() public selectedOption: EventEmitter<boolean> = new EventEmitter();

    // required inputs
    @Input() option1: string;
    @Input() option2: string;

    // valid
    public valid = true;

    @ViewChild('option1Input') option1Input: ElementRef;
    @ViewChild('option2Input') option2Input: ElementRef;

    constructor() {}

    ngOnInit() {
        this.validateSwitch();
    }

    onSwitchChange() {
        this.selectedOption.emit(this.option1Input.nativeElement.checked);
    }

    validateSwitch() {
        this.valid = !!this.option1 && !!this.option2;
    }
}
